import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material'
import moment from 'moment'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import NormalAbnormal from '../NormalAbnormal'
import AssessmentText from '../AssessmentText'
import BigModal from '../../../../../components/Modals/BigModal'

const Neuro = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })
  const [openCranialNerves, setOpenCranialNerves] = useState(false)
  const [openFastTest, setOpenFastTest] = useState(false)

  return (
    <Stack gap={2} padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Neurological Assessment</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <NormalAbnormal
          fieldName="Mental Status"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <NormalAbnormal
          fieldName="Muscle Tone"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <NormalAbnormal
          fieldName="Muscle Strength"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <NormalAbnormal
          fieldName="Gait + Balance"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <NormalAbnormal
          fieldName="Coordination"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <NormalAbnormal
          fieldName="Speech + Language"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Stack direction="row" gap={1}>
            <Button
              onClick={() => setOpenFastTest(true)}
              size="small"
              variant="contained"
              color={
                moduleValues?.Face || moduleValues?.Arms || moduleValues?.Speech
                  ? 'success'
                  : 'primary'
              }
            >
              FAST Test
            </Button>
            <Button
              onClick={() => setOpenCranialNerves(true)}
              size="small"
              variant="contained"
              color={
                Object.keys(moduleValues).some((x) => x.startsWith('CN'))
                  ? 'success'
                  : 'primary'
              }
            >
              Cranial Nerve Assessment
            </Button>
          </Stack>
        </Grid>
        <AssessmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Neurological', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
        <BigModal open={openFastTest} onClose={() => setOpenFastTest(false)}>
          <Stack padding={1} alignItems="center" gap={2}>
            <Grid container spacing={1}>
              <NormalAbnormal
                fieldName="Face"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
              />
              <NormalAbnormal
                fieldName="Arms"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
              />
              <NormalAbnormal
                fieldName="Speech"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
              />
            </Grid>
            <Box>
              <Button
                onClick={() => setOpenFastTest(false)}
                variant="contained"
              >
                Submit
              </Button>
            </Box>
          </Stack>
        </BigModal>
        <BigModal
          open={openCranialNerves}
          onClose={() => setOpenCranialNerves(false)}
        >
          <Stack padding={1} alignItems="center" gap={2}>
            <Grid container spacing={1}>
              <NormalAbnormal
                fieldName="CN I"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Olfactory Nerve (CN I)"
                popupHelperText="Have the patient identify a scent with their eyes closed"
              />
              <NormalAbnormal
                fieldName="CN II"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Optic Nerve (CN II)"
                popupHelperText="Assess patient's visual field and acuity"
              />
              <NormalAbnormal
                fieldName="CN III"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Oculomotor Nerve (CN III)"
                popupHelperText="Assess eye movement, eyelid movement, and pupils"
              />
              <NormalAbnormal
                fieldName="CN IV"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Trochlear Nerve (CN IV)"
                popupHelperText="Assess eye movement (down and laterally)"
              />
              <NormalAbnormal
                fieldName="CN V"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Trigeminal Nerve (CN V)"
                popupHelperText="Assess jaw movement / chewing, and facial sensation at forehead, cheeks and chin"
              />
              <NormalAbnormal
                fieldName="CN VI"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Abducens Nerve (CN VI)"
                popupHelperText="Assess eye movement (laterally and diagonally)"
              />
              <NormalAbnormal
                fieldName="CN VII"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Facial Nerve (CN VII)"
                popupHelperText="Facial expressions - ask patient to frown, smile, raise eyebrows, puff cheeks, and close eyes tightly"
              />
              <NormalAbnormal
                fieldName="CN VIII"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Vestibocochlear Nerve (CN VIII)"
                popupHelperText="Hearing and Balance - Assess Gait & Balance"
              />
              <NormalAbnormal
                fieldName="CN IX"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Glossopharyngeal (CN IX)"
                popupHelperText="Gagging and swallowing - assess upward movement of soft palate"
              />
              <NormalAbnormal
                fieldName="CN X"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Vagus Nerve (CN X)"
                popupHelperText="Pharynx & Larynx sensation & swallowing"
              />
              <NormalAbnormal
                fieldName="CN XI"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Spinal Accessory Nerve (CN XI)"
                popupHelperText="Assess shoulder shrugging and head rotation"
              />
              <NormalAbnormal
                fieldName="CN XII"
                moduleValues={moduleValues}
                setModuleValues={setModuleValues}
                helperTextHeader="Hypoglossal Nerve (CN XII)"
                popupHelperText="Tongue movement and speech"
              />
            </Grid>
            <Box>
              <Button
                onClick={() => setOpenCranialNerves(false)}
                variant="contained"
              >
                Submit
              </Button>
            </Box>
          </Stack>
        </BigModal>
      </Grid>
    </Stack>
  )
}

export default Neuro
